


















import {Component, Vue} from "vue-property-decorator";
import {ACTION_SELECT_LESSON, LessonListEntry} from "../store/CourseProgress";

@Component
export default class Lessons extends Vue {
    get lessons() {
        return this.$store.getters.lessons;
    }
    getButtonText(entry: LessonListEntry) {
        return entry.hasProgress ? this.$t("lessons.continueLessonLabel") : this.$t("lessons.startLessonLabel");
    }
    getButtonVariant(entry: LessonListEntry) {
        return entry.hasProgress ? "success" : "primary"
    }
    getImageSource(entry: LessonListEntry) {
        return `${BASE_URL}lessons/${entry.id}.png`;
    }

    startLevel(lessonId: string) {
        this.$store.dispatch(ACTION_SELECT_LESSON, lessonId);
        this.$router.push(`/lessons/${lessonId}/levels/`);
    }
}
